import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled/macro'
import { SearchBar } from '../../components/search-bar'

const NoResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 130px;
`

const LocationImg = styled.img`
  height: 92px;
  width: 92px;
`

const Title = styled.div`
  max-width: 602px;
  color: #2c2e2f;
  font-family: PayPalSansBig-Regular;
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  margin: 54px auto 36px;
`

const Subtitle = styled.div`
  color: #2c2e2f;
  font-family: PayPal Sans Big;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin-bottom: 12px;
`

const NoSearchResults = ({
  title,
  subtitle,
  searchLabel,
  onSubmit,
  enableSeeYourLocation,
  currentLocationLabel,
  setCurrentBrowserLoccation,
}) => {
  return (
    <NoResultsContainer>
      <LocationImg
        src="https://www.paypalobjects.com/paypal-ui/illustrations/svg/location.svg"
        alt=""
      />
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
      <SearchBar
        placeholder={searchLabel}
        onSubmit={onSubmit}
        enableSeeYourLocation={enableSeeYourLocation}
        currentLocationLabel={currentLocationLabel}
        setCurrentBrowserLoccation={setCurrentBrowserLoccation}
      />
    </NoResultsContainer>
  )
}

NoSearchResults.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  searchLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  enableSeeYourLocation: PropTypes.bool,
  currentLocationLabel: PropTypes.string,
  setCurrentBrowserLoccation: PropTypes.func,
}

export default NoSearchResults
